import InboxIcon from "@mui/icons-material/Inbox";

import { Box, Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function EmptyState({ onReset }) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        py: {
          xs: 5,
          sm: 8,
        },

        textAlign: "center",
      }}
    >
      <Stack spacing={2} alignItems="center">
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "action.hover",
            color: "text.secondary",
          }}
        >
          <InboxIcon
            sx={{
              fontSize: 32,
            }}
          />
        </Box>

        <Typography variant="h6" fontWeight={700}>
          {t("Keine Meldungen gefunden")}
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            maxWidth: 320,
          }}
        >
          {t("Für die aktuelle Auswahl wurden keine passenden Meldungen gefunden.")}
        </Typography>

        {onReset && (
          <Button
            variant="outlined"
            onClick={onReset}
            sx={{
              mt: 1,
              borderRadius: 3,
              textTransform: "none",
            }}
          >
            {t("Filter zurücksetzen")}
          </Button>
        )}
      </Stack>
    </Box>
  );
}
